import { gsap, ScrollTrigger } from "../layout";

// bootstrap
import Modal from 'bootstrap/js/dist/modal';

const documentsUrl = documentsDataPhp;
let modalDocument;
let documentId = null;

function setDocumentData() {
	// modal inti
	modalDocument = new Modal(document.querySelector('#modalDocument'))
	const buttonsDownload = document.querySelectorAll('.document-download-js')

	// attach event listener to download button
	buttonsDownload.forEach(button => {
		button.addEventListener('click', (e) => {
			e.preventDefault()
			modalDocument.show()
			documentId = button.dataset.document

			const index = documentsUrl.findIndex(doc => doc['ID'] === Number(documentId))
			const dataDocument = documentsUrl[index];
			const titleDocument = dataDocument.title;

			document.querySelector('#documentTitle').value = titleDocument
		})
	});
}

function downloadDocumentUrl() {

	// create a link after cf 7 sent, it create element <a> and append the url for download
	document.addEventListener('wpcf7mailsent', (e) => {
		modalDocument.hide()

		const index = documentsUrl.findIndex(doc => doc['ID'] === Number(documentId))

		const dataDocument = documentsUrl[index];
		const urlDocument = dataDocument.url
		const titleDocument = dataDocument.title

		const link = document.createElement('a');
		link.href = urlDocument;
		link.download = 'Yayasan Penyu - ' + titleDocument;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	})
}

document.addEventListener('DOMContentLoaded', () => {
	setDocumentData()
	downloadDocumentUrl()
})

window.addEventListener('resize', () => {
        
})